<span (click)="changeShowfilter(!showFilter)">
    <i class="fas fa-fw fa-filter" [style.opacity]="showFilter ? '1' : '0.5'"></i>
    <span *ngIf="showFilter">{{'filter.hideFilter' | translate }}</span>
    <span *ngIf="!showFilter">{{'filter.showFilter' | translate }}</span>
</span>